import type { EmailSMTPSettings } from "metabase-types/api";

import { Api } from "./api";
import {
  invalidateTags,
  provideSubscriptionChannelListTags,
  tag,
} from "./tags";

export type SendCustomEmailRequest = {
  subject: string;
  body: string;
  /** Selects the To audience. */
  recipient_type: "all" | "users" | "groups";
  user_ids?: number[];
  group_ids?: number[];
  /**
   * Carbon copy. Anyone already in To is dropped from CC, and anyone in To or CC is
   * dropped from BCC, so nobody receives the same mail twice.
   */
  cc_user_ids?: number[];
  cc_group_ids?: number[];
  bcc_user_ids?: number[];
  bcc_group_ids?: number[];
};

export type SendCustomEmailResponse = {
  ok: true;
  /** Total addressed across all three fields. */
  sent: number;
  to: number;
  cc: number;
  bcc: number;
};

export const settingsApi = Api.injectEndpoints({
  endpoints: (builder) => ({
    sendCustomEmail: builder.mutation<
      SendCustomEmailResponse,
      SendCustomEmailRequest
    >({
      query: (body) => ({
        method: "POST",
        url: `/api/email/send-custom`,
        body,
      }),
    }),
    sendTestEmail: builder.mutation<void, void>({
      query: () => ({
        method: "POST",
        url: `/api/email/test`,
      }),
    }),
    updateEmailSMTPSettings: builder.mutation<void, EmailSMTPSettings>({
      query: (emailSettings) => ({
        method: "PUT",
        url: `/api/email`,
        body: emailSettings,
      }),
      invalidatesTags: (_, error) =>
        invalidateTags(error, [
          tag("session-properties"),
          ...provideSubscriptionChannelListTags(),
        ]),
    }),
    deleteEmailSMTPSettings: builder.mutation<void, void>({
      query: () => ({
        method: "DELETE",
        url: `/api/email`,
      }),
      invalidatesTags: (_, error) =>
        invalidateTags(error, [
          tag("session-properties"),
          ...provideSubscriptionChannelListTags(),
        ]),
    }),
  }),
});

export const {
  useDeleteEmailSMTPSettingsMutation,
  useSendCustomEmailMutation,
  useSendTestEmailMutation,
  useUpdateEmailSMTPSettingsMutation,
} = settingsApi;
